import { attributesButtonSchema } from "./attributes.js";
import { validate } from "../../helpers/validate.js";
import { guideButtonHtml } from "../../elements/button/component.js";
const scalarButton = {
  name: "scalar-button",
  tagName: "scalar-button",
  tiptapName: "custom_button",
  attributeTransform: (_, attrs) => {
    return validate(attributesButtonSchema, {
      title: typeof attrs.title === "string" ? attrs.title : "",
      href: typeof attrs.href === "string" ? attrs.href : "",
      icon: typeof attrs.icon === "string" ? attrs.icon : typeof attrs.icon?.src === "string" ? attrs.icon?.src : ""
    });
  },
  render: guideButtonHtml
};
import { ScalarButtonVue } from "./component.js";
export {
  ScalarButtonVue,
  scalarButton
};
//# sourceMappingURL=index.js.map
